import { memo } from 'react'
import clsx from 'clsx'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { useLayout } from '../../core'
import searchIcon from '../../../../_metronic/assets/images/svg/data-room/search-icon-grey.svg'
import { useEffect, useState, useRef } from 'react'
import { useAuth } from '../../../../app/modules/auth'
import { DisplayImage } from '../../../../app/modules/widgets/components/General/DisplayImage'
import { BasicButton } from '../../../../app/modules/widgets/components/UI/BasicButton'
import { useIntl } from 'react-intl'
import { getAllCompany } from '../../../../app/modules/investor-crm/core/_requests'
import { updateUserDefaultCompany } from '../../../../app/modules/profile/core/_requests'
import '../toolbar/styles/sidebar.scss'
import { Modal } from 'react-bootstrap'
import TagManager from 'react-gtm-module'
import { companyDetailsMeta, GTMEvent } from '../../../../app/hooks/gtmHelpers'
import { companyData } from '../../../../app/modules/profile/core/_requests'
import { removeNullFields } from '../../../../app/core/_util'
import NewCompanyModal from '../../../../app/modules/setting/view/NewCompanyModal'
import SwitchingCompany from '../../../../app/modules/setting/view/SwitchingCompany'
import Skeleton from 'react-loading-skeleton'
import { getUserByToken, refreshTokenApi } from '../../../../app/modules/auth/core/_requests'

const SidebarLogo = () => {
  const { formatMessage } = useIntl()
  const {
    currentUser,
    storeCompanyId,
    companyId,
    setRole,
    currentState,
    selected,
    billingData,
    currencyBill,
    setCompanyQueuePosition,
    setInvoiceStatus,
    setPlanStatus,
    setUserToken,
    setUseCase,
    saveAuth,
  } = useAuth()

  const [allCompanyData, setAllCompanyData] = useState<any[]>()
  const { config } = useLayout()
  const dropdownRef = useRef<HTMLDivElement>(null)
  const [isActive, setIsActive] = useState(false)

  const appSidebarDefaultMinimizeDesktopEnabled =
    config?.app?.sidebar?.default?.minimize?.desktop?.enabled
  const appSidebarDefaultCollapseDesktopEnabled =
    config?.app?.sidebar?.default?.collapse?.desktop?.enabled
  const toggleType = appSidebarDefaultCollapseDesktopEnabled
    ? 'collapse'
    : appSidebarDefaultMinimizeDesktopEnabled
      ? 'minimize'
      : ''
  const toggleState = appSidebarDefaultMinimizeDesktopEnabled ? 'active' : ''
  const [selectCompany, setSelectedCompany] = useState<any>(null)
  const [search, setSearch] = useState<string>('')
  const [filteredCompany, setFilteredCompany] = useState<any[]>()
  const [noResultsMatched, setNoResultsMatched] = useState(false)
  const [isMoreCompanies, setIsMoreCompanies] = useState(false)
  const storedCompany = localStorage.getItem('company')
  const company = storedCompany ? JSON.parse(storedCompany) : null
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const appSidebarDefaultMinimizeDefault = config.app?.sidebar?.default?.minimize?.desktop?.default

  useEffect(() => {
    getAllCompanies()
  }, [search, currentUser, selectCompany, companyId]) // eslint-disable-line

  const getAllCompanies = async () => {
    try {
      setIsLoading(true)
      const {
        data: { success, data },
      } = await getAllCompany(10, search, true)
      if (success) {
        handleSetFilteredCompanies(data)
        setNoResultsMatched(data.length === 0)
      } else {
        setFilteredCompany([])
        setNoResultsMatched(true)
      }
    } catch (error) {
      console.log(error)
      setFilteredCompany([])
      setNoResultsMatched(true)
    } finally {
      setIsLoading(false)
    }
  }
  const handleSetFilteredCompanies = (companies: any) => {
    let updatedCompanies = companies

    // Check if there's a search query and sort alphabetically by companyName
    if (search.trim()) {
      updatedCompanies = companies.sort((a: any, b: any) => a.name.localeCompare(b.name))
    } else {
      // Add selected company to filtered companies if not already included
      if (
        selectCompany &&
        !companies.some((company: any) => company.companyId === selectCompany.companyId)
      ) {
        updatedCompanies = [selectCompany, ...companies]
      }
    }
    setFilteredCompany(updatedCompanies)
  }

  useEffect(() => {
    setAllCompanyData(currentUser?.company)
    if (companyId) {
      const findCompany = currentUser?.company.find(
        (company: { companyId: number }) => company.companyId === companyId
      )
      if (findCompany) {
        setSelectedCompany(findCompany)
        // if (isRecordskeeper) {
        setRole(findCompany?.roles?.roleName?.toLowerCase())
        // } else {
        //   setRole(findCompany?.roles?.user_role.roleId)
        // }
      } else {
        setSelectedCompany(currentUser?.company[0])
      }
    }

    if (company?.companyId) {
      setSelectedCompany(company)
    } else if (selectCompany === null && !companyId) {
      setSelectedCompany(currentUser?.company[0])
    }
  }, [currentUser, companyId]) // eslint-disable-line

  const refreshToken = async (itemCompany: number) => {
    try {
      const {
        data: { success, data },
      } = await refreshTokenApi()

      if (success) {
        await saveAuth(data)
        setUserToken(data.token)

        if (data?.companyPlanStatus?.invoiceStatus) {
          setInvoiceStatus(data.companyPlanStatus.invoiceStatus)
        }
        if (data?.companyPlanStatus?.planStatus) {
          setPlanStatus(data.companyPlanStatus.planStatus)
        }
        const { data: userData } = await getUserByToken(data.token)
        if (userData?.data) {
          const findCompany = userData?.data?.company?.find(
            (company: { companyId: number }) => company.companyId === itemCompany
          )
          if (findCompany) {
            setCompanyQueuePosition(findCompany?.queuePosition)
            setUseCase(findCompany?.useCase)
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const onCompanySelect = async (item: any) => {
    setIsLoading(true)
    try {
      if (item) {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.CompanySwitchInitiatedSuccessful,
            action: 'normal',
            metadata: removeNullFields({
              company_id: companyId,
              company_switch_id: item.companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              current_state: currentState,
              selected,
              billing_data: billingData,
              currency_bill: currencyBill,
            }),
          },
        })
        setSelectedCompany(item)
        const findCompany = currentUser?.company.find(
          (comp: { companyId: number }) => comp.companyId === item.companyId
        )
        if (findCompany) {
          // if (isRecordskeeper) {
          setRole(findCompany?.roles?.roleName?.toLowerCase())
          // } else {
          //   setRole(findCompany?.roles?.user_role.roleId)
          // }
        }

        const {
          data: { success, data: value, errors },
        }: any = await updateUserDefaultCompany(companyId!, item.companyId)
        // Update filtered companies with the selected company at the top
        if (success) {
          if (value?.companyPlanStatus?.invoiceStatus) {
            setInvoiceStatus(value?.companyPlanStatus?.invoiceStatus)
          }
          if (value?.companyPlanStatus?.planStatus) {
            setPlanStatus(value?.companyPlanStatus?.planStatus)
          }
          const {
            data: { success, data },
          } = await companyData(item.companyId)
          if (success) {
            storeCompanyId(item.companyId)
            setCompanyQueuePosition(item?.queuePosition)
            localStorage.setItem('company', JSON.stringify(item))
            localStorage.setItem('companyId', item.companyId)
            refreshToken(item.companyId)
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.CompanySwitchCompletedSuccessful,
                action: 'normal',
                metadata: removeNullFields(
                  companyDetailsMeta({
                    ...data,
                    company_id: item.companyId,
                    profile_image: data.file?.name,
                  })
                ),
              },
            })
            if (`${window.location.hostname}` === 'localhost') {
              window.location.href = `${window.location.protocol}//${window.location.hostname}:3002/dashboard`
            } else {
              window.location.href = `${window.location.protocol}//${window.location.hostname}/dashboard`
            }
          } else {
            errors.forEach((error: string) => {
              console.log(error)
            })
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.CompanySwitchCompletedFailed,
                action: 'normal',
                metadata: removeNullFields({
                  company_id: companyId,
                  company_switch_id: item.companyId,
                  queue_position: item.queuePosition,
                  error: errors[0],
                }),
              },
            })
          }
        }
      }
    } catch (error) {
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.CompanySwitchInitiatedFailed,
          action: 'normal',
          metadata: removeNullFields({
            company_id: companyId,
            company_switch_id: item.companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            current_state: currentState,
            selected,
            billing_data: billingData,
            currency_bill: currencyBill,
            error: error,
          }),
        },
      })
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      const dropdownElement = document.getElementById('panelsStayOpen-collapseThree')
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && dropdownElement) {
        dropdownElement.classList.remove('show')
      }
    }

    document.addEventListener('click', handleClickOutside)

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])
  const [isActiveSwitching, setIsActiveSwitching] = useState(false)

  console.log(allCompanyData, 'allCompanyData')
  console.log(filteredCompany, 'filteredCompany')

  return (
    <div
      className='app-sidebar-logo border-0 px-md-6 px-0 d-flex pt-5 pt-md-auto pt-lg-0 aligner'
      id='kt_app_sidebar_logo'
    >
      <div className='w-100'>
        <div className='accordion-item px-2' ref={dropdownRef}>
          <h2 className='accordion-header' id='panelsStayOpen-headingThree'>
            <button
              className='accordion-button collapsed w-100 app-sidebar-logo-default custom-accordion-button'
              type='button'
              data-bs-toggle='collapse'
              data-bs-target='#panelsStayOpen-collapseThree'
              aria-expanded='false'
              aria-controls='panelsStayOpen-collapseThree'
            >
              <button className='btn d-flex p-0 px-1 px-md-0 justify-content-between align-items-center w-100 py-3 '>
                <div className='d-flex gap-1 align-items-center'>
                  <DisplayImage
                    imgName={selectCompany?.file?.name}
                    alt='comp'
                    height='30px'
                    width='30px'
                    fit='contain'
                    className='rounded-2'
                  />

                  <h4 className='align-self-left ps-2 text-dark font-size-13 fw-bold ps-3 m-0 text-start'>
                    {/* {selectCompany?.name} */}
                    {selectCompany && selectCompany?.name?.length >= 15
                      ? selectCompany?.name.slice(0, 13) + '...'
                      : selectCompany?.name}
                  </h4>
                </div>

                <i
                  className='align-self-center fa fa-angle-down ps-2 text-clr477 text-primary'
                  aria-hidden='true'
                ></i>
              </button>
            </button>
          </h2>
          <div className='w-100 app-sidebar-logo-minimize d-flex rounded-2'>
            <DisplayImage
              imgName={selectCompany?.file?.name}
              alt='comp'
              height='30px'
              width='30px'
              fit='contain'
              className={'app-sidebar-logo-minimize rounded-2'}
            />
          </div>

          <div
            id='panelsStayOpen-collapseThree'
            className='accordion-collapse p-2 bg-white collapse w-100 shadow border-bottom mh-1000px rounded-2 position-absolute'
            style={{ zIndex: '99' }}
            aria-labelledby='panelsStayOpen-headingThree'
          >
            <div className='accordion-body app-sidebar-logo-default mh-550px bg-white'>
              {/* {allCompanyData && allCompanyData?.length > 5 && ( */}
              {filteredCompany && (
                <div className='border border-1 rounded-3 mb-2'>
                  <form
                    data-kt-search-element='form'
                    className='align-items-center d-flex position-relative'
                    autoComplete='off'
                  >
                    <KTSVG
                      path='/media/icons/duotune/general/gen021.svg'
                      className='svg-icon-3 position-absolute ms-3'
                    />
                    <input
                      type='text'
                      className='form-control ps-10 h-40px rounded-2 font-weight-400 outline-none border-0'
                      name='search'
                      placeholder={formatMessage({ id: 'Search' })}
                      data-kt-search-element='input'
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </form>
                </div>
              )}

              {noResultsMatched && (
                <div
                  className={`d-flex justify-content-center my-4 font-size-14 ${isLoading ? 'd-none' : ''
                    }`}
                >
                  {formatMessage({ id: 'Result not matched' })}
                </div>
              )}
              <div className='d-flex flex-column gap-2 mb-4'>
                {/* All companies Logic  */}
                {isLoading ? (
                  <>
                    <div>
                      {Array.from({ length: 5 }).map((_, index) => (
                        <div key={index} className='d-flex align-items-center gap-2 w-200px'>
                          <Skeleton
                            height={24}
                            width={24}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            className='mb-4'
                          />
                          <div className={`fw-bold m-0 font-size-13 d-flex ms-1`}>
                            <Skeleton
                              height={20}
                              width={200}
                              baseColor='var(--kt-skeleton-bg-color)'
                              highlightColor='var(--kt-skeleton-highlight-bg-color)'
                              className='mb-4'
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  allCompanyData &&
                  filteredCompany &&
                  filteredCompany
                    .slice() // Make a copy of the array to avoid mutating the original
                    .sort((a, b) =>
                      selectCompany && a.companyId === selectCompany.companyId
                        ? -1
                        : b.companyId === selectCompany.companyId
                          ? 1
                          : 0
                    )
                    .slice(0, 5)
                    .map((item) => (
                      <>
                        <div key={item.companyId}>
                          <button
                            className={`btn ${selectCompany &&
                              selectCompany.companyId === item.companyId &&
                              'btn-light'
                              }  col-12 d-flex w-100 align-items-center p-2 justify-content-between gap-2 px-2`}
                            data-bs-toggle='collapse'
                            data-bs-target='#panelsStayOpen-collapseThree'
                            aria-expanded='false'
                            aria-controls='panelsStayOpen-collapseThree'
                            onClick={() => {
                              onCompanySelect(item)
                              setIsActiveSwitching(true)
                            }}
                          >
                            <div className='d-flex align-items-center gap-2 w-200px'>
                              <DisplayImage
                                imgName={item.file?.name}
                                alt='img'
                                height='30px'
                                width='30px'
                                fit='contain'
                                className={'rounded-2'}
                              />
                              <div
                                className={`fw-bold m-0 font-size-13 d-flex ms-1 ${selectCompany && selectCompany.companyId === item.companyId
                                  ? 'text-clr477'
                                  : 'text-dark'
                                  }`}
                                style={{ width: '180px' }}
                              >
                                <p className='m-0'>
                                  {item?.name.length > 20
                                    ? item.name.slice(0, 20) + '...'
                                    : item?.name}
                                </p>
                              </div>
                            </div>

                            {selectCompany && selectCompany.companyId === item.companyId && (
                              <i
                                className='align-self-center p-0 ms-1 col-2 fa fa-check text-clr477 text-primary'
                                style={{ flexBasis: 'fit-content' }}
                                aria-hidden='true'
                              ></i>
                            )}
                          </button>
                          <SwitchingCompany
                            isActive={isActiveSwitching}
                            setIsActive={setIsActiveSwitching}
                          />
                        </div>
                      </>
                    ))
                )}
                {/* Companies count logic  */}
                {filteredCompany && filteredCompany.length > 5 && !search && !noResultsMatched && (
                  <div
                    className={`'py-4 d-flex ms-2 cursor-pointer ${isLoading ? 'd-none' : ''}`}
                    onClick={() => setIsMoreCompanies(true)}
                  >
                    <img
                      src={toAbsoluteUrl('/media/icons/duotune/general/company_location.svg')}
                      width={24}
                      height={24}
                      alt='Company location'
                    />
                    <p className='align-self-center col-8 fw-bold m-0 text-primary text-wrap font-size-13 d-flex ms-1'>
                      & {filteredCompany.length - 5} More{' '}
                      {filteredCompany.length - 5 === 1 ? 'Company' : 'Companies'}
                    </p>
                  </div>
                )}
              </div>
              {isMoreCompanies && (
                <MoreCompanies
                  isMoreCompanies={isMoreCompanies}
                  setIsMoreCompanies={setIsMoreCompanies}
                  filteredCompanies={filteredCompany}
                  selectCompany={selectCompany}
                  companySelectHandler={onCompanySelect}
                  setSearch={setSearch}
                  search={search}
                  setIsActive={setIsActive}
                  onCompanySelect={onCompanySelect}
                  isActiveSwitching={isActiveSwitching}
                  setIsActiveSwitching={setIsActiveSwitching}
                />
              )}

              <div className='d-flex justify-content-center py-2'>
                <BasicButton
                  buttonText={formatMessage({ id: 'Add New Company' })}
                  height='auto'
                  border='none'
                  color='#4776E6'
                  textColor='#FFFFFF'
                  padding='12px 21px'
                  onClick={() => {
                    // setNewCompany(false)
                    setIsActive(true)
                    setIsMoreCompanies(false)
                  }}
                  // minWidth={225}
                  customClass='w-100 px-0 px-md-auto'
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {(appSidebarDefaultMinimizeDesktopEnabled || appSidebarDefaultCollapseDesktopEnabled) && (
        <div
          id='kt_app_sidebar_toggle'
          className={clsx(
            'app-sidebar-toggle btn btn-icon  btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute sidebar-btn-mobile-view top-50 start-100 translate-middle rotate',
            { active: appSidebarDefaultMinimizeDefault }
          )}
          data-kt-toggle='true'
          data-kt-toggle-state={toggleState}
          data-kt-toggle-target='body'
          data-kt-toggle-name={`app-sidebar-${toggleType}`}
        >
          <KTSVG path='/media/icons/duotune/arrows/arr079.svg' className='svg-icon-2 rotate-180' />
        </div>
      )}

      <NewCompanyModal
        isActive={isActive}
        setIsActive={setIsActive}
        getAllCompanies={getAllCompanies}
      />
    </div>
  )
}

export default memo(SidebarLogo)

interface MoreCompaniesProps {
  isMoreCompanies: boolean
  setIsMoreCompanies: (value: boolean) => void
  filteredCompanies: any
  selectCompany: any
  companySelectHandler: any
  setSearch: any
  search: string
  setIsActive: React.Dispatch<React.SetStateAction<boolean>>
  onCompanySelect: (item: any) => void
  isActiveSwitching: any
  setIsActiveSwitching: any
}

const MoreCompanies: React.FC<MoreCompaniesProps> = (
  {
    isMoreCompanies,
    setIsMoreCompanies,
    filteredCompanies,
    selectCompany,
    companySelectHandler,
    setSearch,
    search,
    setIsActive,
    onCompanySelect,
    isActiveSwitching,
    setIsActiveSwitching
  },
  prop
) => {
  const { formatMessage } = useIntl()
  const [loadingCompanyId, setLoadingCompanyId] = useState(null)
  // const [isActiveSwitching, setIsActiveSwitching] = useState(false)

  return (
    <Modal show={isMoreCompanies} onHide={() => setIsMoreCompanies(false)} size='md' {...prop}>
      <Modal.Header closeButton>
        <h2>{formatMessage({ id: 'All Companies' })}</h2>
      </Modal.Header>
      <Modal.Body>
        <div className='d-flex align-items-center'>
          <form className='align-items-center d-flex position-relative w-100'>
            <span className='svg-icon svg-icon-3 position-absolute ms-2'>
              <img src={searchIcon} alt='Search icon' />
            </span>
            <input
              type='text'
              data-kt-inbox-listing-filter='search'
              className='bg-body bg-white form-control form-control-flush ps-10 rounded-2 font-size-12 font-weight-400 py-3 border'
              placeholder='Search'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </form>
        </div>
        <div
          className='my-4'
          style={{ maxHeight: '400px', overflowY: 'scroll', scrollbarWidth: 'none' }}
        >
          {filteredCompanies &&
            filteredCompanies?.length > 0 &&
            filteredCompanies
              .slice()
              .sort((a: any, b: any) =>
                selectCompany && a.companyId === selectCompany.companyId
                  ? -1
                  : b.companyId === selectCompany.companyId
                    ? 1
                    : 0
              )
              .map((company: any, index: any) => (
                <>
                  <div className='mb-2 cursor-pointer' key={company.id}>
                    <div
                      className={`d-flex justify-content-between align-items-center gap-2 p-3 rounded ${selectCompany.companyId === company.companyId ? 'bg-light' : ''
                        }`}
                      onClick={() => {
                        companySelectHandler(company)
                        setIsMoreCompanies(false);
                        setIsActiveSwitching(true)
                      }}
                    >
                      <div className='d-flex align-items-center gap-2'>
                        <DisplayImage
                          imgName={''}
                          alt='profile pic'
                          height={32}
                          width={32}
                          className='rounded-circle'
                        />
                        <h5
                          className={`m-0 fw-semibold ${selectCompany.companyId === company.companyId ? 'text-primary' : ''
                            } `}
                        >
                          {company?.name.length > 40
                            ? company.name.slice(0, 40) + '...'
                            : company.name}
                        </h5>
                      </div>
                      {selectCompany && selectCompany.companyId === company.companyId ? (
                        <i
                          className='align-self-center p-0 me-3 col-2 fa fa-check text-clr477 text-primary'
                          style={{ flexBasis: 'fit-content' }}
                          aria-hidden='true'
                        ></i>
                      ) : (
                        <>
                          <div
                            className='text-primary d-flex align-items-center gap-2 justify-content-end cursor-pointer'
                            onClick={() => {
                              setLoadingCompanyId(company.companyId)
                              setIsActiveSwitching(true)
                              onCompanySelect(company)
                              setIsMoreCompanies(false)
                            }}
                          >
                            <img
                              src={toAbsoluteUrl('/media/icons/duotune/general/ic-switch.svg')}
                              alt=''
                            />
                            <p className='mb-0 text-nowrap'>
                              {loadingCompanyId === company.companyId
                                ? 'Please wait...'
                                : 'Switch Company'}
                            </p>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </>
              ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className='btn bg-primary text-white custom-button-property'
          onClick={() => {
            // setNewCompany(false)
            setIsActive(true)
            setIsMoreCompanies(false)
          }}
        >
          {formatMessage({ id: 'Add New Company' })}
        </button>
      </Modal.Footer>
    </Modal >
  )
}
